import { computed } from "vue";
import { useProfileStore } from "@/modules/settings/stores/useProfileStore";
/**
 * Single frontend source of truth for application-level access, read from the
 * accessible-applications set the BFF reconciles on the user-profile payload.
 * Sits beside `usePermissions` (capability gating) — two reads of the same
 * profile bootstrap, on different axes: capabilities gate actions, applications
 * gate whole areas (sidebar entries, landing).
 */
export function useApplicationAccess() {
    const profileStore = useProfileStore();
    const accessibleCodes = computed(() => profileStore.profile?.accessibleApplications?.map((app) => app.code.toLowerCase()) ?? []);
    const hasApplicationData = computed(() => accessibleCodes.value.length > 0);
    const canAccess = (code) => !hasApplicationData.value || accessibleCodes.value.includes(code.toLowerCase());
    const defaultApplicationCode = computed(() => profileStore.profile?.defaultApplicationCode?.toLowerCase() ?? null);
    const isReady = computed(() => !!profileStore.profile);
    return { accessibleCodes, hasApplicationData, canAccess, defaultApplicationCode, isReady };
}
